export enum DATA_TYPES {
  COURSE = 'course',
  LESSON = 'lesson',
  ITCL = 'itcl',
  VTCL = 'vtcl',
  CATCL = 'catcl',
  LIST = 'list',
  KEY_VALUE = 'key_value'
}

export enum VIEW_TYPES {
  DETAILED = 'detailed',
  ANYFEED = 'anyfeed'
}

export enum ITCL_SUBDATA_TYPES {
  ICON_CARD = 'icon_card'
}

type ListItemType = {
  icon: string;
  iconColor: string;
  title: string;
  titleColor: string;
};

export type ITCLCtaType = {
  title: string;
  description: string | null;
  titleColor: string | null;
  backgroundColor: string | null;
  type: string;
  category: string;
};

export type ITCLImageType = {
  image: string;
  type: string;
};

export type ITCLListType = {
  items: ListItemType[];
  type: string;
};

export type ITCLTitle = {
  title: string;
  description: string | null;
  descriptionColor: string | null;
  style: string;
  titleColor: string;
};

export type DataType = {
  uuid: string;
  dataType: DATA_TYPES;
  subDataType: string;
  cardType: string;
  marginTop: string | null;
  marginBottom: string | null;
  isViewMore: boolean;
  extendedViewType: string | null;
  title: string;
  titleType: string | null;
  titlePlacement: string | null;
  icon: string | null;
  description: string;
  itemPlacement: number[];
  defaultItemPlacement: number;
};

export interface AnyfeedDataProps {
  data: DataType;
  list: any[];
}
